//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { IAvailableInstagramBusinessAccount } from '@apis/instagram-settings/gatewayInstagramSettingsApiModel';
import InstagramBusinessAccountId from '@models/InstagramBusinessAccountId';
import { Normalized } from '@utils/normalize';

export enum INSTAGRAM_SETTINGS_MODAL_ACTIONS {
  OPEN_MODAL = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/OPEN_MODAL',
  CLOSE_MODAL = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/CLOSE_MODAL',

  REQUEST_AVAILABLE_ACCOUNTS = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/REQUEST_AVAILABLE_ACCOUNTS',
  RECEIVE_AVAILABLE_ACCOUNTS_SUCCEEDED = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/RECEIVE_AVAILABLE_ACCOUNTS_SUCCEEDED',
  RECEIVE_AVAILABLE_ACCOUNTS_FAILED = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/RECEIVE_AVAILABLE_ACCOUNTS_FAILED',

  SET_SELECTED_ACCOUNT = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/SET_SELECTED_ACCOUNT',
  SET_SELECTED_ACCOUNTS = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/SET_SELECTED_ACCOUNTS',

  REQUEST_SAVE_SELECTED_ACCOUNT = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/REQUEST_SAVE_SELECTED_ACCOUNT',
  RECEIVE_SAVE_SELECTED_ACCOUNT_SUCCEEDED = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/RECEIVE_SAVE_SELECTED_ACCOUNT_SUCCEEDED',
  RECEIVE_SAVE_SELECTED_ACCOUNT_FAILED = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/RECEIVE_SAVE_SELECTED_ACCOUNT_FAILED',

  REQUEST_SAVE_SELECTED_ACCOUNTS = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/REQUEST_SAVE_SELECTED_ACCOUNTS',
  RECEIVE_SAVE_SELECTED_ACCOUNTS_SUCCEEDED = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/RECEIVE_SAVE_SELECTED_ACCOUNTS_SUCCEEDED',
  RECEIVE_SAVE_SELECTED_ACCOUNTS_FAILED = 'INSTAGRAM_SETTINGS_MODAL_ACTIONS/RECEIVE_SAVE_SELECTED_ACCOUNTS_FAILED',
}

export interface IInstagramSettingsModalState {
  flags: {
    isFetchingAvailableAccounts: boolean;
    isOpen: boolean;
    isSavingSelectedAccount: boolean;
  };
  availableAccounts: Normalized<IAvailableInstagramBusinessAccount, string>;
  saveSelectedAccountError?: string;
  selectedAccountId?: InstagramBusinessAccountId;
  selectedAccountIds?: InstagramBusinessAccountId[];
  saveSelectedAccountErrors?: string;
}
